import React, { FC } from 'react';

import SpecialPublicationPreAccessContainer from 'buyside/components/presentation/SpecialPublicationPreAccess/SpecialPublicationPreAccessContainer';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

const SpecialPublicationPreAccessPageRoot: FC<{ specialPublicationId: string }> = ({
  specialPublicationId
}) => {
  if (!specialPublicationId) return;

  return (
    <ErrorBoundary pageName="form users submit to view special publication">
      <SpecialPublicationPreAccessContainer specialPublicationId={specialPublicationId} />
    </ErrorBoundary>
  );
};

export default SpecialPublicationPreAccessPageRoot;
